import {useContext} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import {useMount} from '@s-ui/react-hooks'
import MoleculeModal from '@s-ui/react-molecule-modal'
import MoleculeNotification, {
  moleculeNotificationAlignItems,
  moleculeNotificationBorderSizes,
  moleculeNotificationTypes,
  moleculeNotificationVariations
} from '@s-ui/react-molecule-notification'
import {useLocation} from '@s-ui/react-router'
import ModalBasicContent from '@adv-mt/mt-modal-basic-content'
import IconCircleCheck from '@adv-mt/mt-svg-icons/lib/CircleCheck.js'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close.js'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {useMessagingContext} from '../../useMessagingContext/index.js'
import {TransactionContentAd} from './TransactionContentAd.js'

// eslint-disable-next-line react/prop-types
const ModalContent = ({adId, isSellerFlow}) => {
  const {page} = useAnalyticsTrack()

  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')

  const {TRANSACTION_BUYER_LEGAL_CONDITIONS_SUCCESS_PAGE_NAME, TRANSACTION_SELLER_LEGAL_CONDITIONS_SUCCESS_PAGE_NAME} =
    config.get('page')

  useMount(async () => {
    const getTrackingData = async () => {
      return domain.get('get_page_tracking_data_use_case').execute({
        page: isSellerFlow
          ? TRANSACTION_SELLER_LEGAL_CONDITIONS_SUCCESS_PAGE_NAME
          : TRANSACTION_BUYER_LEGAL_CONDITIONS_SUCCESS_PAGE_NAME
      })
    }

    const pageTrackingData = await getTrackingData()
    page(pageTrackingData)
  })

  return (
    <div className="mt-TransactionConfirmTermsAndConditions-modalContent">
      {i18n.t(
        isSellerFlow
          ? 'VEHICLE_TRANSACTION.PURCHASE_ACCEPT_REQUEST_MODAL.TEXT'
          : 'VEHICLE_TRANSACTION.PURCHASE_REQUEST_MODAL.TEXT'
      )}
      {adId ? <TransactionContentAd adId={adId} /> : <></>}
    </div>
  )
}

export const ConfirmTermsAndConditionsTransactionModal = () => {
  const {state: routerState} = useLocation()
  const {i18n} = useContext(Context)
  const {setInteractionComponent} = useMessagingContext()

  const {adId, isSellerFlow} = routerState || {}

  return (
    <MoleculeModal
      isOpen
      closeOnOutsideClick
      closeOnEscKeyDown
      iconClose={<IconClose size={ATOM_ICON_SIZES.medium} />}
      onClose={() => setInteractionComponent({component: null, show: false})}
      size="large"
    >
      <div className="mt-TransactionConfirmTermsAndConditions-modalContainer">
        <MoleculeNotification
          alignItems={moleculeNotificationAlignItems.CENTER}
          autoClose={null}
          icon={<IconCircleCheck size="medium" />}
          position="relative"
          roundedCorners={moleculeNotificationBorderSizes.medium}
          show
          showCloseButton={false}
          showLeftIconMobile
          type={moleculeNotificationTypes.success}
          variation={moleculeNotificationVariations.positive}
        >
          {i18n.t('VEHICLE_TRANSACTION.BUYER_CHECK_COSTS_LIST.MODAL_CONFIRM.NOTIFICATION_TEXT')}
        </MoleculeNotification>
        <ModalBasicContent
          stepsContent={[
            {
              buttons: {
                confirmButton: {
                  customCallBack: () => {
                    setInteractionComponent({component: null, show: false})
                  },
                  text: i18n.t('COMMON.UNDERSTOOD'),
                  type: 'accent'
                }
              },
              children: <ModalContent adId={adId} isSellerFlow={isSellerFlow} />,
              title: i18n.t(isSellerFlow ? 'COMMON.REQUEST_ACCEPTED' : 'COMMON.REQUEST_SENT')
            }
          ]}
        />
      </div>
    </MoleculeModal>
  )
}

ConfirmTermsAndConditionsTransactionModal.displayName = 'ConfirmTermsAndConditionsTransactionModal'
